import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API, apiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono");
      return;
    }
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-700 bg-white p-8 shadow-2xl">
        <h1 className="mb-6 text-2xl font-extrabold tracking-tight">Nuova password</h1>
        {!token ? (
          <div data-testid="reset-missing-token" className="rounded-lg border border-rose-300 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-800">
            Link non valido: manca il token.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              data-testid="reset-password"
              type="password"
              required
              minLength={8}
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 w-full rounded-lg border border-input px-4 text-base outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
              placeholder="Nuova password (min. 8 caratteri)"
            />
            <input
              data-testid="reset-password-confirm"
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="h-12 w-full rounded-lg border border-input px-4 text-base outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
              placeholder="Conferma password"
            />
            {error && (
              <div data-testid="reset-error" className="rounded-lg border border-rose-300 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-800">
                {error}
              </div>
            )}
            <button
              data-testid="reset-submit"
              type="submit"
              disabled={loading}
              className="h-12 w-full rounded-lg bg-blue-600 text-base font-bold text-white transition-colors hover:bg-blue-700 disabled:opacity-60"
            >
              {loading ? "Salvataggio…" : "Reimposta password"}
            </button>
          </form>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm font-semibold text-blue-600 hover:underline">
            Torna al login
          </Link>
        </div>
      </div>
    </div>
  );
}
